import * as Constants from '../../constants';

import { useState, useEffect, useCallback } from 'react';

import classes from "./FIIsList.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

import ScrollContainer from '../../components/UI/ScrollContainer';
import Card from '../../components/UI/Card';

import Loading from '../../components/UI/Loading';
import FIIsFilterForm from '../../components/FIIsFilterForm';
import AdvertisementPanel from '../../components/UI/AdvertisementPanel';

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

function FIIsList(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [fiis, setFIIs] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filtersText, setFiltersText] = useState("");
  const [fiisFiltrados, setFIIsFiltrados] = useState([]);
  const [filterFormIsShown, setFilterFormIsShown] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("");

  const fetchFIIsHandler = useCallback(async () => {
    setIsLoading(true);
    try {
      const lastUpdateReponse = await fetch(Constants.PUBLIC_FIIS_LAST_UPDATE);
      const lastUpdateData = await lastUpdateReponse.json();
      setLastUpdate(lastUpdateData);

      const response = await fetch(Constants.PUBLIC_FIIS_LIST);
      if (!response.ok) {
        alert('deu pau');
        throw new Error('Something went wrong!');
      }

      const data = await response.json();

      const loadedFIIs = [];
      for (let item in data) {
        const element = data[item];
        let fii = {
          id: element.id,
          codigo: element.ticker,
          ticker: element.ticker,
          setor: element.sector,
          subsetor: element.subsector,
          price: element.currentPrice,
          expense: element.expense,
          vacancy: element.vacancy,
          pvp: (element.pvp.trim() !== "-" ? element.pvp : ""),
          vpc: element.vpc,
          dy: element.dy,
          vD: element.vD,
          vM: element.vM,
          vY: element.vY,
          rXP: element.rXP,
          xPoupanca: element.xPoupanca,
          d: element.d,
          dy1: element.dy1,
          dy3: element.dy3,
          dy6: element.dy6,
          dy12: element.dy12,
          dyIPO: element.dyIPO,
          lqd: element.lqd,
          adm: element.adm,
          cotas: element.cotas,
          cotistas: element.cotistas
        }
        loadedFIIs.push(fii);
      }
      setFIIs(loadedFIIs);
      setFIIsFiltrados(loadedFIIs);
    } catch (error) {
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    fetchFIIsHandler();
  }, [fetchFIIsHandler]);

  useEffect(() => {
    if (fiis.length > 0)
      setIsLoading(false);
  }, [fiis]);

  useEffect(() => {
    let str = "";
    if (Object.keys(filters).length > 0) {
      str += '<strong style="color:#0A58CA">' + Object.keys(filters).length + ' filtros aplicados</strong>: ';
      str += (filters.codigo && filters.codigo.value && filters.codigo.value.length > 0 ? "<strong>Código</strong> contém '" + filters.codigo.value + "', " : "");
      str += (filters.setor && filters.setor.value && filters.setor.value.length > 0 ? "<strong>Setor</strong> contém '" + filters.setor.value + "', " : "");
      str += (filters.subsetor && filters.subsetor.value && filters.subsetor.value.length > 0 ? "<strong>Segmento:</strong> contém '" + filters.subsetor.value + "', " : "");
      str += (filters.lqd && filters.lqd.operator !== "" ? "<strong>Liquidez diária</strong> " + filters.lqd.operator + " " + filters.lqd.value + ", " : "");
      str += (filters.vacancy && filters.vacancy.operator !== "" ? "<strong>Vacância</strong> " + filters.vacancy.operator + " " + filters.vacancy.value + ", " : "");
      str += "<br/>";
      str += (filters.xPoupanca && filters.xPoupanca.operator !== "" ? "<strong>Rendimento x Poupança</strong> " + filters.xPoupanca.operator + " " + filters.xPoupanca.value + "%, " : "");
      str += (filters.pvp && filters.pvp.operator !== "" ? "<strong>P/VP</strong> " + filters.pvp.operator + " " + filters.pvp.value + ", " : "");

      str += (filters.dy1 && filters.dy1.operator !== "" ? "<strong>DY 1 mês</strong> " + filters.dy1.operator + " " + filters.dy1.value + "%, " : "");

      str += (filters.dy3 && filters.dy3.operator !== "" ? "<strong>DY 3 meses</strong> " + filters.dy3.operator + " " + filters.dy3.value + "%, " : "");
      str += (filters.dy6 && filters.dy6.operator !== "" ? "<strong>DY 6 meses</strong> " + filters.dy6.operator + " " + filters.dy6.value + "%, " : "");
      str += (filters.dy12 && filters.dy12.operator !== "" ? "<strong>DY 12 meses</strong> " + filters.dy12.operator + " " + filters.dy12.value + "%, " : "");
      str += (filters.dyIPO && filters.dyIPO.operator !== "" ? "<strong>DY desde IPO</strong> " + filters.dyIPO.operator + " " + filters.dyIPO.value + "%, " : "");

      str += (filters.mL && filters.mL.operator !== "" ? "<strong>Margem Líquida</strong> " + filters.mL.operator + " " + filters.mL.value + "%, " : "");
      str += (filters.dlpl && filters.dlpl.operator !== "" ? "<strong>Dívida Líquida/PL</strong> " + filters.dlpl.operator + " " + filters.dlpl.value + "%, " : "");
      str += (filters.vD && filters.vD.operator !== "" ? "<strong>Variação 1Dia</strong> " + filters.vD.operator + " " + filters.vD.value + "%, " : "");
      str += (filters.vM && filters.vM.operator !== "" ? "<strong>Variação 1Mês</strong> " + filters.vM.operator + " " + filters.vM.value + "%, " : "");
      str += (filters.vY && filters.vY.operator !== "" ? "<strong>Variação 1Ano</strong> " + filters.vY.operator + " " + filters.vY.value + "%, " : "");
      str += (filters.price && filters.price.operator !== "" ? "<strong>Preço</strong> " + filters.price.operator + " R$ " + filters.price.value + ", " : "");
      str = str.substring(0, str.length - 2);
    }
    if(str.length === 0) str = "<br/><br/>";    
    setFiltersText(str);
  }, [filters]);
  const showHideFilterFormHandler = () => {
    setFilterFormIsShown(!filterFormIsShown);
  };

  const filtersHandler = (filters) => {
    setFilters(filters);
    setFilterFormIsShown(false);
    const filtered = fiis.filter(item => {
      return Object.keys(filters).every(key => {
        const filtroValor = filters[key]?.value;
        const filtroOperador = filters[key]?.operator;
        const itemValor = item[key];
        // Ignorar se o valor do filtro for undefined, vazio ou zero
        if (filtroValor === undefined || filtroValor === "" || filtroOperador === 0) {
          return true;
        }

        // Para valores string, realizar comparação parcial similar ao LIKE
        if (isNaN(itemValor) && (typeof itemValor === "string" && typeof filtroValor === "string")) {
          return itemValor.toLowerCase().includes(filtroValor.toLowerCase());
        } else {
          // console.warn(key, itemValor, filtroOperador, filtroValor);
          switch (filtroOperador) {
            case ">":
              return Number(itemValor) > Number(filtroValor);
            case ">=":
              return Number(itemValor) >= Number(filtroValor);
            case "<":
              return Number(itemValor) < Number(filtroValor);
            case "<=":
              return Number(itemValor) <= Number(filtroValor);
            case "=":
            default:
              return Number(itemValor) === Number(filtroValor);
          }
        }
      });

    });
    setFIIsFiltrados(filtered);
  };

  const dataAtualFormatada = (dt) => {
    var data = new Date(dt);
    var dia = data.getDate().toString(),
      diaF = (dia.length === 1) ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length === 1) ? '0' + mes : mes,
      anoF = data.getFullYear(),
      hora = (data.getHours().toString().length === 1) ? '0' + data.getHours() : data.getHours(),
      min = (data.getMinutes().toString().length === 1) ? '0' + data.getMinutes() : data.getMinutes(),
      seg = (data.getSeconds().toString().length === 1) ? '0' + data.getSeconds() : data.getSeconds();

    return diaF + "/" + mesF + "/" + anoF + " " + hora + ":" + min + ":" + seg;
  }

  const closeFilterFormHandler = () => {
    setFilterFormIsShown(false);
  };

  const splitString = (text, maxLength = 33) => {
    const words = text.split(" ");
    const line1 = [];
    const line2 = [];

    let currentLength = 0;

    for (let word of words) {
      if (!isNaN(word)) word = word.replace(".", ",") + "%";
      if (currentLength + word.length <= maxLength) { // line1.length accounts for spaces
        line1.push(word);
        currentLength += word.length;
      } else {

        line2.push(word);
      }
    }

    return line1.join(" ") + " " + line2.join(" ");
  }

  return <>
    {isLoading && <Loading />}
    {!isLoading && <>
      <div className="row mainPanel px-2">
        <div className="col col-md-12">
          <Card>
            {filterFormIsShown && <FIIsFilterForm
              // method="POST"
              // onFinishSubmit={finishSubmitAssetHandler}
              // onClose={hideFormHandler}
              updateFilters={filtersHandler}
              closeFilterForm={closeFilterFormHandler}
              filters={filters}
            />}
            <div className='row'>
              <div className='col col-md-4'>

              </div>

              <div className='col col-md-2'>
                {/* <span className="fw-bold">Total Geral:</span> {isNaN(total) ? 0 : brlFormatter.format(total)} */}
              </div>

              <div className='col col-md-2'>
                {/* <span className="fw-bold">Total Investido em Ações:</span> {brlFormatter.format(totalInvestidoFIIs)} */}
              </div>

              <div className='col col-md-2'>
                {/* <span className="fw-bold">Total em Ações:</span> {brlFormatter.format(totalFIIs)} <small>({isNaN(totalFIIs) || totalFIIs === 0 ? '0%' : percentageFormatter.format(totalFIIs / total)})</small> */}
              </div>

              <div className="col col-md-2">
                {/* <span className={(rentabilidadeTotal >= 0 ? 'fw-bold positive' : 'fw-bold negative')}>Rentabilidade:</span> {brlFormatter.format(rentabilidadeTotal)} <small>({isNaN(rentabilidadeTotal) || rentabilidadeTotal === 0 ? '0%' : percentageFormatter.format(rentabilidadeTotal / totalFIIs)})</small> */}
              </div>
            </div>

            <div className='row'>
              <div className='col-2'>
                <Button variant="secondary" className={classes.filterButton} onClick={showHideFilterFormHandler}><FontAwesomeIcon icon={faFilter} /></Button>
                &nbsp;&nbsp;
                <small>
                  <strong>{fiisFiltrados.length}</strong> fundos imobiliários encontrados.
                </small>
              </div>
              <div className='col'><small dangerouslySetInnerHTML={{ __html: filtersText }} /></div>
              <div className='col-2'>
                <small className='lastUpdate'><b>Última atualização:</b>&nbsp;&nbsp;{dataAtualFormatada(lastUpdate)}</small>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <ScrollContainer heightMultiplier={0.73}>
                  <Table striped bordered hover>
                    <thead className={`fixedTableHead ${classes.fixedTableHead}`}>
                      <tr>
                        <th rowSpan="2" className="text-center">CÓDIGO</th>
                        <th rowSpan="2" className={classes.th}>Setor<br /><small>Segmento</small></th>
                        <th rowSpan="2" className={classes.th}>Liquidez<br />Diária</th>
                        <th rowSpan="2" className={classes.th}>Cotas<br /><small>Cotistas</small></th>
                        <th rowSpan="2" className={classes.th}>Taxa de Administração<br /><small>Administrador</small></th>
                        <th rowSpan="2" className={classes.th}>Vacância</th>
                        <th rowSpan="2" className={classes.th}>Rendimento<br /> x Poupança</th>
                        <th rowSpan="2" className={classes.th}>P/VP</th>
                        <th rowSpan="2" className={classes.th}>VP por<br />cota</th>
                        <th colSpan="5" className={classes.blue6}>Dividendos</th>
                        <th colSpan="3" className={classes.blue5}>Variação</th>
                        <th colSpan="2" rowSpan="2" className={classes.th}>Preço<br />Atual</th>
                      </tr>
                      <tr>
                        <th colSpan="1" className={classes.blue5}>1 Mês</th>
                        <th className={classes.blue4}>3 Meses</th>
                        <th className={classes.blue3}>6 Meses</th>
                        <th className={classes.blue2}>12 Meses</th>
                        <th className={classes.blue1}>IPO</th>
                        <th className={classes.blue3}>1 Dia</th>
                        <th className={classes.blue2}>1 Mês</th>
                        <th className={classes.blue1}>1 Ano</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fiis.length === 0 && <tr>
                        <td colSpan='24'>Nenhum ativo cadastrado.</td>
                      </tr>
                      }
                      {
                        fiisFiltrados.map((fii) => <tr key={fii.id}>
                          <td className={classes.td + " text-center"}>
                            <span className={"font-weight-bold"}>{fii.ticker}</span><br />
                            <a href={`${Constants.BASE_URL_BRA_FII_INVESTIDOR10}${fii.ticker}`} target='_blank' rel="noreferrer" title='Investidor10'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_BRA_FII_FUNDSEXPLORER}${fii.ticker}`} target='_blank' rel="noreferrer" title='FundsExplorer'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_BRA_FII_INFOMONEY}${fii.ticker}`} target='_blank' rel="noreferrer" title='InfoMoney'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>
                          </td>
                          <td className={classes.td}>{fii.setor}<br /><small>{fii.subsetor}</small></td>
                          <td className={classes.td}><small>{fii.lqd !== '' && !isNaN(fii.lqd) ? brlFormatter.format(fii.lqd) : ""}</small></td>
                          <td className={classes.td}>{fii.cotas}<br /><small>{fii.cotistas}</small></td>
                          <td className={classes.td}>{splitString(fii.expense)}<br /><small>{fii.adm}</small></td>
                          <td className={classes.td}>{fii.vacancy !== '' && !isNaN(fii.vacancy) ? percentageFormatter.format(fii.vacancy / 100) : ""}</td>
                          <td className={classes.td + "" + (fii.xPoupanca < 0 ? " text-danger" : "")}>{fii.pvp !== '' && !isNaN(fii.xPoupanca) ? percentageFormatter.format(fii.xPoupanca / 100) : ""}</td>
                          <td className={classes.td + "" + (fii.pvp < 1 ? " text-success" : "")}>{fii.pvp !== '' && !isNaN(fii.pvp) ? fii.pvp.replace(".", ",") : ""}</td>
                          <td className={classes.td + "" + (fii.vpc < fii.currentPrice ? " text-sucess" : "")}>{fii.vpc !== '' && !isNaN(fii.vpc) ? brlFormatter.format(fii.vpc) : ""}</td>
                          <td className={classes.td}>{fii.dy1 !== '' && !isNaN(fii.dy1) ? percentageFormatter.format(fii.dy1 / 100) : ""}<br /><small>{fii.d !== '' && !isNaN(fii.d) ? brlFormatter.format(fii.d) : ""}</small></td>
                          <td className={classes.td}>{fii.dy3 !== '' && !isNaN(fii.dy3) ? percentageFormatter.format(fii.dy3 / 100) : ""}</td>
                          <td className={classes.td}>{fii.dy6 !== '' && !isNaN(fii.dy6) ? percentageFormatter.format(fii.dy6 / 100) : ""}</td>
                          <td className={classes.td}>{fii.dy12 !== '' && !isNaN(fii.dy12) ? percentageFormatter.format(fii.dy12 / 100) : ""}</td>
                          <td className={classes.td}>{fii.dyIPO !== '' && !isNaN(fii.dyIPO) ? percentageFormatter.format(fii.dyIPO / 100) : ""}</td>
                          <td className={classes.td + "" + (fii.vD < 0 ? " text-danger" : "")}>{fii.vD !== '' && !isNaN(fii.vD) ? percentageFormatter.format(fii.vD / 100) : ""}</td>
                          <td className={classes.td + "" + (fii.vM < 0 ? " text-danger" : "")}>{fii.vM !== '' && !isNaN(fii.vM) ? percentageFormatter.format(fii.vM / 100) : ""}</td>
                          <td className={classes.td + "" + (fii.vY < 0 ? " text-danger" : "")}>{fii.vY !== '' && !isNaN(fii.vY) ? percentageFormatter.format(fii.vY / 100) : ""}</td>
                          <td className={classes.td + "" + (fii.price < fii.currentPrice ? " text-danger" : "")}>{fii.price !== '' && !isNaN(fii.price) ? brlFormatter.format(fii.price) : ""}</td>
                        </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </ScrollContainer>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <div className="row adPanel px-2">
        <div className="col col-md-12">
          <AdvertisementPanel
          title="Conheça nossas soluções"
          description="Tecnologia e inovação para transformar seus negócios."
          image="https://terradata.com.br/img/logo.png"
          link="https://www.terradata.com.br"
          height={100}
        />
        </div>
      </div>
    </>
    }
  </>
}

export default FIIsList;
